// src/Muestras/Drawer/sections/SaveBar.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export default function SaveBar({
  muestra,
  onCancel,
  onSaveAndClose,
  onCreateSample,
  userCanCreateSample,
  saving = false,
  keepOpenAfterSave = false,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleConfirm = async () => {
    if (saving) return;
    setOpenConfirm(false);
    if (onCreateSample) {
      await onCreateSample();
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          zIndex: 8,
          px: 1.75,
          py: 1.1,
          borderTop: "1px solid",
          borderColor: "divider",
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          flexWrap: "wrap",
          backgroundColor: theme.palette.background.paper,
          backdropFilter: "blur(8px)",
          boxShadow:
            theme.palette.mode === "dark"
              ? `0 -4px 24px ${alpha("#000", 0.35)}`
              : `0 -4px 20px ${alpha("#000", 0.06)}`,
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          onClick={onCancel}
          disabled={saving}
          sx={{ minWidth: 100, borderRadius: 2, textTransform: "none" }}
        >
          {t("Samples.cancel")}
        </Button>

        {userCanCreateSample && (
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            disabled={saving}
            onClick={() => setOpenConfirm(true)}
            sx={{ minWidth: 180, borderRadius: 2, textTransform: "none" }}
          >
            {t("Samples.addToCriticalPath")}
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={saving}
          onClick={onSaveAndClose}
          startIcon={
            saving ? <CircularProgress size={14} color="inherit" /> : null
          }
          sx={{
            minWidth: 140,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 700,
          }}
        >
          {saving
            ? t("Samples.saving")
            : keepOpenAfterSave
              ? t("Samples.save")
              : t("Samples.saveAndClose")}
        </Button>
      </Box>

      <Dialog
        open={openConfirm}
        onClose={() => !saving && setOpenConfirm(false)}
      >
        <DialogTitle>{t("Samples.addToCriticalPathTitle")}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {t("Samples.addToCriticalPathBody", {
              name: muestra?.MUESTRA || "",
            })}
            <br />
            <br />
            {t("Samples.addToCriticalPathWarning")}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setOpenConfirm(false)}
            variant="outlined"
            color="inherit"
            disabled={saving}
          >
            {t("Samples.cancel")}
          </Button>

          <Button
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            disabled={saving}
          >
            {t("Samples.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
